import styled from 'styled-components';
import { flex, media, position } from '../../core';

export const LoaderStyled = styled.div`
  background-color: rgba(255,255,255,0.8);
  ${flex('column', 'center', 'center')};
  ${position('fixed', '0', '0', '0', '0')};
  z-index: 100000;
`;

export const LoaderContainer = styled.div`
  img {
    height: auto;
    max-width: 9.375rem;
    @media ${media.desktopMin} {
      max-width: 10.9375rem;
    }
  }
`;
